import BaseDevice from '../base.js'
import Inner from './inner.js'
export default class DeviceImage extends BaseDevice {
   static render = (device, scale = 1) => {
      const baseWidth = STORAGE.getSetting('baseWidth', BASE_WIDTH)
      const MODS = device.width / baseWidth

      if (MODS < 2.5 || MODS > 5) return;

      return this.getDevice(device, scale, Inner.render(device.width));
   }
}
